import { render } from "./ImageDetail.vue?vue&type=template&id=64b016dc&scoped=true"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"

import "./ImageDetail.vue?vue&type=style&index=0&id=64b016dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b016dc"]])

export default __exports__